/* global pipwerks */
export function isInScormLMS() {
  return window.pipwerks;
}

export function initScormSession() {
  console.log("try to initialize scorm session", pipwerks);
  let ok = pipwerks.SCORM.init();
  console.log("successfull: ", ok);
}

export function saveScormSession() {
  console.log("try to save scorm session", pipwerks);
  let ok = pipwerks.SCORM.save();
  console.log("successfull: ", ok);
}

export function saveScormData(data) {
  if (data && data !== "") {
    console.log("try to save scorm data...");
    let ok = pipwerks.SCORM.set("cmi.suspend_data", data);
    console.log("set cmi.suspend_data successfull: ", ok);
    ok = pipwerks.SCORM.save();
    console.log("save successfull: ", ok);
  }
}

export function getScormData() {
  console.log("try to get scorm data...");
  let data = pipwerks.SCORM.get("cmi.suspend_data");
  console.log("data: ", data);
  return data;
}

export function finishScormSession() {
  console.log("try to set scorm status to completed");
  let ok = pipwerks.SCORM.set("cmi.core.lesson_status", "completed");
  pipwerks.SCORM.set("TELUSTAT", "completed");
  console.log("successfull: ", ok);

  console.log("try to initialize scorm object", pipwerks);
  ok = pipwerks.SCORM.quit();
  console.log("successfull: ", ok);
}

export function setScore(score) {
  console.log("try to set scorm value object...");
  let ok = pipwerks.SCORM.set("cmi.core.score.raw", score);
  pipwerks.SCORM.set("TRAWSCORE", score);
  console.log("successfull: ", ok);
  ok = pipwerks.SCORM.save();
  console.log("save successfull: ", ok);
}

export function setLessonLocation(location) {
  pipwerks.SCORM.set("cmi.core.lesson_location", location);
}

export function setSessionTime(time) {
  pipwerks.SCORM.set("cmi.core.session_time", time);
  pipwerks.SCORM.set("TTIMEELU", time);
}

export function getStudentName() {
  return pipwerks.SCORM.set("cmi.core.student_name");
}
